module.exports = __webpack_public_path__ + "img/creator-grant.2b5062e.svg";